<template>
    <div
        v-if="Object.keys(videos).length"
        class="videos"
        @mouseenter="$emit('mouseenter')"
        @mouseleave="$emit('mouseleave')"
        @click="$emit('click')"
    >
        <TheVideo
                v-for="(queue, id) in videoQueue"
                :key="`video_${id}`"
                :id="parseInt( id )"
                :startVideo="startVideo"
                :zIndex="queue.zIndex"
        />
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import filter from 'lodash/filter';
import TheVideo from './TheVideo.vue';

export default {
    name: 'Videos',
    components: { TheVideo },
    props: {
        startVideo: {}
    },
    computed: {
        ...mapGetters(['videos', 'videoQueue']),
    }
};
</script>

<style scoped>
    .videos {
        width: 100% !important;
        height: 100% !important;
    }
</style>

